import { render, staticRenderFns } from "./ProfileActivity.vue?vue&type=template&id=a6b191d2&"
import script from "./ProfileActivity.vue?vue&type=script&lang=js&"
export * from "./ProfileActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports